import React from "react";

type RowProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};
export default function Row({ children = {}, style = {} }: RowProps) {
  return (
    <div style={{ ...style }} className="row">
      {children}
    </div>
  );
}
